module.exports = __webpack_public_path__ + "static/media/avishkar_andhale.03ad6b50.jpg";